/* eslint-disable react/require-default-props */
import React, { FC } from 'react';
import classNames from 'classnames';
import { Popover } from 'react-bootstrap';

import './PopoverTooltip.scss';

export interface PopoverTooltipProps {
  children?: React.ReactNode;
  className?: string;
  id: string;
  passedProps?: any;
}

const PopoverTooltip: FC<PopoverTooltipProps> = (props) => {
  const { children, className, id, passedProps } = props;
  return (
    <Popover id={id} className={classNames('PopoverTooltip', className)} {...passedProps}>
      <Popover.Content>{children}</Popover.Content>
    </Popover>
  );
};

PopoverTooltip.defaultProps = {
  children: undefined,
  className: undefined,
  passedProps: undefined,
};

export { PopoverTooltip };
